<div class="container" data-test-selector="product-description">
  <div class="row justify-content-between">
    <div class="col-3">
        <div class="justify-content-center flex-column">
        <span data-test-selector="product-catalog-number">
          @if (product.productSource === 'aptitude'){
            <i class="apt-icon apt-logo-icon"></i>
          }
          <a [routerLink]="productUrl" (click)="this.activeModal.close()">{{ product.catalogNumber }}</a>
        </span>
        <div data-test-selector="product-catalog-description" class="product-description-detail .text-truncate">
          {{ product.description }}
        </div>
      </div>
    </div>

    @if(!featureFlags?.CONSUME_PRODUCT_DATA_MD_CAT_964488) {
      <div class="border-start col-2">
        <div class="justify-content-center flex-column">
          <div data-test-selector="seller-name">{{ product.seller.name }}</div>
          @if (product.seller.name !== product.sysSeller.name){
            <div data-test-selector="sys-seller-name" class="text-muted">
              {{ product.sysSeller.name }}
            </div>
          }
        </div>
      </div>

      <div class="border-start"
        [ngClass]="product.brandName ? 'col-2' : 'col-4'">
        <div class="justify-content-center flex-column">
          <div data-test-selector="category-section">
            <app-category-path-component
            [categories]="product.categories" ></app-category-path-component>
          </div>
        </div>
      </div>

      @if (product.brandName){
        <div class="col-2 border-start">
          <div class="justify-content-center flex-column">
            <div data-test-selector="product-brand">
              {{ product.brandName }}
            </div>
          </div>
        </div>
      }
    }

    @if(featureFlags?.CONSUME_PRODUCT_DATA_MD_CAT_964488) {
      <div class="border-start col-2">
        <div class="justify-content-center flex-column">
          <div data-test-selector="manufacturer-name">{{ product.manufacturer.name }}</div>
          @if (product.manufacturer.name !== product.parentManufacturer?.name){
            <div data-test-selector="parent-manufacturer-name" class="text-muted">
              {{ product.parentManufacturer?.name }}
            </div>
          }
        </div>
      </div>

      <div class="border-start col-2">
        <div class="justify-content-center flex-column">
          <div data-test-selector="distributor-name">{{ product.distributor?.name }}</div>
          @if (product.distributor?.name !== product.parentDistributor?.name){
            <div data-test-selector="parent-distributor-name" class="text-muted">
              {{ product.parentDistributor?.name }}
            </div>
          }
        </div>
      </div>

      <div class="border-start"
        [ngClass]="product.brandName ? 'col-2' : 'col-3'">
        <div class="justify-content-center flex-column">
          <div data-test-selector="category-section">
            <app-category-path-component
                [categories]="product.categories.slice(0,1)">
            </app-category-path-component>
          </div>
        </div>
      </div>

      @if (product.brandName){
        <div class="col-1 border-start">
          <div class="justify-content-center flex-column">
            <div data-test-selector="product-brand">
              {{ product.brandName }}
            </div>
          </div>
        </div>
      }
    }

    <div class="border-start px-4"
        data-test-selector="product-cross-reference-count"
        [ngClass]="{'ms-auto col-auto' : !isVoteVisible, 'col-1': isVoteVisible}">
      <div class="h-100 d-flex align-items-center">
        <i class="fas fa-globe-americas"></i>
        <span class="mx-1" data-test-selector="product-cross-count-number">
          {{ totalCrossesCount }}
        </span>
      </div>
    </div>

    @if (isVoteVisible) {
      <div class="col-auto border-start text-center product-cross-thumbs-up-and-down-count"
        data-test-selector="product-cross-thumbs-up-and-down-count">
      <div class="h-100 d-flex align-items-center">
        <i data-test-selector="product-cross-thumbs-up-count"
            class="fa fa-thumbs-up"
            [ngClass]="{ 'text-primary' : upCount > 0, 'apt-mid-gray': upCount == 0 }"
            title="The number of crosses you have approved for this product">
          <span [class]="{ 'apt-mid-gray' : upCount == 0 }"  class="mx-1 fw-normal">
            {{ upCount || 0 }}
          </span>
        </i>
        <i data-test-selector="product-cross-thumbs-down-count"
            class="fa fa-thumbs-down"
            [ngClass]="{ 'text-danger' : downCount > 0, 'apt-mid-gray': downCount == 0 }"
            title="The number of crosses you have disputed for this product">
          <span [class]="{ 'apt-mid-gray': downCount == 0 }" class="mx-1 fw-normal">
            {{ downCount || 0 }}
          </span>
        </i>
      </div>
    </div>
    }
  </div>
</div>
